export function replaceDiacritics(str: string) {
    str = `${str}`;
    const diacritics = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];
    const chars = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];
    for (let i = 0; i < diacritics.length; i++) {
        str = str.replace(diacritics[i], chars[i]);
    }
    return str;
};

const isNumeric = (x: string) => /^\d+$/.test(x);
const isUppercase = (x: string) => /^[A-Z]+$/.test(x);
const isLowerCase = (x: string) => /^[a-z]+$/.test(x);

enum CharGroup {
    Other = 0,
    Digit = 1,
    UpperCase = 2,
    LowerCase = 3
}
const getCharGroup = (str: string): CharGroup => {
    if (str === undefined || str == null) return CharGroup.Other;
    if (isNumeric(str)) return CharGroup.Digit;
    if (isUppercase(str)) return CharGroup.UpperCase;
    if (isLowerCase(str)) return CharGroup.LowerCase;
    return 0;
}

function groupNames(name: string) {
    const charArr = Array.from(name).map((x, i, arr) => ([x, arr[i+1]]));
    const result = [];
    let group = [];
    let prevGroup = [];
    for(const [curr, next] of charArr) {
        const currGroup = getCharGroup(curr);
        const nextGroup = getCharGroup(next);
        if (currGroup !== 0) {
            group.push(curr);
        }
        if (nextGroup !== currGroup && group.length > 1) {
            prevGroup = group;
            group = [];
            if (currGroup === CharGroup.UpperCase && nextGroup !== CharGroup.Other) {
                group.push(prevGroup.pop());
            }
            result.push(" " + prevGroup.join(""));
        }
    }
    result.push(" " + group.join(""));
    return result.join("");
}

function splitName(name: string): string[] {
    return groupNames(replaceDiacritics(String(name))).split(' ').filter(x => x);
}

const upperCaseFirst = (str: string) => [str.charAt(0).toUpperCase(), ...str.slice(1).toLowerCase()].join("");

export const camelCase = (name: string) => {
    const words = splitName(name);
    const first = words.shift();
    return [first?.toLowerCase(), ...words.map(x => upperCaseFirst(x))].join("");
};

export const pascalCase = (name: string) => {
    return splitName(name).map(x => upperCaseFirst(x)).join("");
};

export const snakeCase = (name: string) => {
    return splitName(name).map(x => x.toLowerCase()).join("_");
};

export const snakeCaseUpper = (name: string) => {
    return splitName(name).map(x => x.toUpperCase()).join("_");
};

export const kebabCase = (name: string) => {
    return splitName(name).map(x => x.toUpperCase()).join("-");
};
